__turbopack_context__.v({
  "item": "kE5BhW_item",
  "itemCopied": "kE5BhW_itemCopied",
  "popover": "kE5BhW_popover",
  "popoverTitle": "kE5BhW_popoverTitle",
  "trigger": "kE5BhW_trigger",
  "wrap": "kE5BhW_wrap",
});
